import { useOutletContext } from "react-router-dom";
import { Quote } from "lucide-react";
import { Container, Reveal, Eyebrow, PageBanner, siteImg } from "@/site/ui";
import TestimonialSlider from "@/site/TestimonialSlider";

export default function Testimonials() {
  const c = useOutletContext();
  return (
    <div data-testid="testimonials-page">
      <PageBanner image={c.banners?.testimonials} eyebrow="Testimonials" title="Living better, in their words" subtitle="Real stories from the people at the heart of everything we do." />

      <section className="pt-16 md:pt-20 pb-12">
        <Container>
          <Reveal>
            <div className="rounded-[32px] bg-[#0A0A0A] p-8 sm:p-12 md:p-16">
              <TestimonialSlider items={c.testimonials} dark />
            </div>
          </Reveal>
        </Container>
      </section>

      <section className="py-16 md:py-24">
        <Container>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {c.testimonials.map((t, i) => (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <figure data-testid={`testimonial-card-${i}`} className="h-full rounded-2xl border border-gray-100 bg-white p-8 shadow-sm">
                  <Quote size={30} className="text-[rgb(var(--rgh-primary-rgb)/0.25)]" />
                  <blockquote className="mt-4 text-base leading-relaxed text-[#0A0A0A]">“{t.quote}”</blockquote>
                  <figcaption className="mt-6">
                    <p className="text-sm font-semibold text-[var(--rgh-primary)]">{t.name}</p>
                    <p className="text-xs text-[#525252]">{t.location}</p>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
